import * as Models from "../.";

export interface IOpportunityAssociatedEpcCalculationOptionByProduct {
    epcCalculationOptions: Models.CostCalculation.EpcCalculationOption.IOpportunityAssociatedEpcCalculationOption[];
    product: string;
}

export class OpportunityAssociatedEpcCalculationOptionByProduct implements IOpportunityAssociatedEpcCalculationOptionByProduct {
    epcCalculationOptions: Models.CostCalculation.EpcCalculationOption.IOpportunityAssociatedEpcCalculationOption[];
    product: string;

    constructor(
        product: string,
        epcCalculationOptions: Models.CostCalculation.EpcCalculationOption.IOpportunityAssociatedEpcCalculationOption[]
    ) {
        this.product = product;
        this.epcCalculationOptions = epcCalculationOptions;
    }
}

export interface IEpcCalculationOptionByProduct {
    epcCalculationOptions: Models.CostCalculation.EpcCalculation.IEpcCalculationResult[];
    product: string;
}

export class EpcCalculationOptionByProduct implements IEpcCalculationOptionByProduct {
    epcCalculationOptions: Models.CostCalculation.EpcCalculation.IEpcCalculationResult[];
    product: string;

    constructor(
        product: string,
        epcCalculationOptions: Models.CostCalculation.EpcCalculation.IEpcCalculationResult[]
    ) {
        this.product = product;
        this.epcCalculationOptions = epcCalculationOptions;
    }
}
